import { stringify as stringifyQs } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../types";

// import urlJoin from "url-join";

const SellerOrdersSection = "/seller-orders";

export const SellerOrdersListPath = SellerOrdersSection;

export enum SellerOrdersListUrlFiltersEnum {
  query = "query",
  orderDateFrom = "orderDateFrom",
  orderDateTo = "orderDateTo",
  orderCompleteDateFrom = "orderCompleteDateFrom",
  orderCompleteDateTo = "orderCompleteDateTo",
  orderCanceledFrom = "orderCanceledFrom",
  orderCanceledTo = "orderCanceledTo"
}

export enum SellerOrdersListUrlFiltersWithMultipleValues {
  mall = "mall",
  orderDate = "orderDate",
  completedAt = "completedAt",
  orderStatus = "orderStatus",
  shippingMethodName = "shippingMethodName",
  deliveryType = "deliveryType",
  storeOrderStatus = "storeOrderStatus"
}
export type SellerOrdersListUrlDialog =
  | "add"
  | "view-store"
  | "assign"
  | "download"
  | TabActionDialog;
export type SellerOrdersListUrlFilters = Filters<
  SellerOrdersListUrlFiltersEnum
> &
  FiltersWithMultipleValues<SellerOrdersListUrlFiltersWithMultipleValues>;

export type SellerOrdersListUrlQueryParams = ActiveTab &
  SellerOrdersListUrlFilters &
  BulkAction &
  Dialog<SellerOrdersListUrlDialog> &
  Pagination &
  SingleAction;

export const SellerOrdersListUrl = (params?: SellerOrdersListUrlQueryParams) =>
  SellerOrdersListPath + "?" + stringifyQs(params);
